import React, { forwardRef, useRef } from 'react'
import { Link } from 'react-router-dom';
import { useDropdownKeyboardNavigation } from '../Custom_Hooks/useDropdownKeyboardNavigation';
import { useDropdownScroll } from '../Custom_Hooks/useDropdownScroll';
import { useDispatch } from 'react-redux';
import { closeModal, openModal } from '../../redux/actions/action-creator';
import { useDropdownFilterForDynamicInput } from '../Custom_Hooks/useDropdownFilterForDynamicInput';
import { useDropdownPosition } from '../Custom_Hooks/useDropdownPosition';


const DropdownForDynamicInput = forwardRef(({ title, state, input_value, input_key, input_id, rawData, data, data_item, setData, setSubmitConfirm, inputRefs, index }, ref) => {
    const dropdownRef = useRef(null)
    const dispatch = useDispatch();
    const coords = useDropdownPosition(state, ref);
    const { filteredData } = useDropdownFilterForDynamicInput({
        dataList: rawData,
        searchInput: input_value,
        inputRef: ref,
    });
    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: filteredData,
        state,
        onItemSelect: (item) => {
            const itemName = item?.ledger_name || item?.name || item?.symbol;
            setData((prevData) => {
                const updatedData = { ...prevData };

                if (typeof index !== "number") {
                    // Update top-level fields like `quantity`, `rate`, `per`, etc.
                    updatedData[input_key] = itemName;
                } else if (typeof index === "number") {
                    // Update array fields within `data_item`
                    updatedData.data_item = updatedData.data_item.map((item_data, i) =>
                        i === index ? {
                            ...item_data,
                            [input_key]: item?.name,
                            location: item?.id || ''
                        } : item_data
                    );
                }
                return updatedData;
            });

            // Handle Navigation after selection
            const fields = ["godown_name", "quantity", "rate", "per", "value"];
            const fieldIdx = fields.indexOf(input_key);
            if (fieldIdx !== -1 && fieldIdx < fields.length - 1) {
                let nextField = fields[fieldIdx + 1];

                // Special skips for Not Applicable units
                if (data?.unit_name === "Not Applicable" && input_key === "godown_name") {
                    nextField = "value";
                }

                const nextKey = typeof index === "number" ? `${nextField}${index} ` : nextField;
                const nextRef = inputRefs?.current?.[nextKey] || inputRefs?.[nextKey]?.current;
                if (nextRef) {
                    setTimeout(() => {
                        nextRef.focus();
                        if (nextRef.setSelectionRange) nextRef.setSelectionRange(0, nextRef.value?.length || 0);
                    }, 50);
                }
            }

            dispatch(closeModal(typeof index === "number" ? `${input_key}${index} ` : input_key))
        },
        onItemAltCSelect: () => {
            // Close the current dropdown and open appropriate creation modal
            dispatch(closeModal(typeof index === "number" ? `${input_key}${index} ` : input_key));

            // Determine which modal to open based on input_key
            if (input_key === 'item_name') {
                // For item fields, open stock item creation modal
                dispatch(openModal("stockItemCreate"));
            } else if (input_key === 'godown_location') {
                dispatch(openModal("godownCreateVoucher"));
            } else {
                dispatch(openModal("ledgerCreate"));
            }
        },
        input_value,
    });

    useDropdownScroll({ dropdownRef, selectedItemIndex });
    return (
        <div 
            className={`dropdown-content-list ${state ? 'show-list' : ''}`}
            style={{
                ...coords,
                display: state ? 'flex' : 'none',
                flexDirection: 'column',
                overflow: 'hidden',
                padding: 0
            }}
        >
            <div className='col' style={{ background: 'skyblue', position: 'sticky', top: 0, flexShrink: 0 }}>
                {title}
            </div>

            <div id='data' ref={dropdownRef} style={{ overflowY: 'auto', flex: 1 }}>
                {
                    Array.isArray(filteredData) && filteredData?.map((key, number) => {
                        const name = key?.ledger_name || key?.name || key?.symbol;
                        // const balance = key?.opening_balance;
                        const id = key?.id;
                        const matchIndex = name?.toLowerCase()?.indexOf(input_value?.toLowerCase());
                        return (
                            <Link
                                className={`list font-weight-bold ${number === selectedItemIndex ? 'selected' : ''}`}
                                id='list'
                                key={number}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedItemIndex(number)
                                    if (number === selectedItemIndex) {
                                        const updatedData = {
                                            ...data,
                                        };

                                        if (typeof index !== "number") {
                                            updatedData[input_key] = name;
                                            if (input_id) updatedData[input_id] = id;
                                        } else {
                                            updatedData.data_item = (data.data_item || data_item).map((item_data, i) =>
                                                i === index ? {
                                                    ...item_data,
                                                    [input_key]: name,
                                                    location: id || ''
                                                } : item_data
                                            );
                                        }

                                        if (input_id === 'group_id') {
                                            updatedData['slug'] = filteredData[selectedItemIndex]?.slug;
                                            updatedData['nature_of_groups'] = filteredData[selectedItemIndex]?.nature_of_group;
                                        }

                                        setData(updatedData);

                                        // Navigation logic for Click
                                        const fields = ["godown_name", "quantity", "rate", "per", "value"];
                                        const fieldIdx = fields.indexOf(input_key);
                                        let nextField = null;

                                        if (fieldIdx !== -1 && fieldIdx < fields.length - 1) {
                                            nextField = typeof index === "number" ? `${fields[fieldIdx + 1]}${index} ` : fields[fieldIdx + 1];

                                            // Special skips
                                            if (data?.unit_name === "Not Applicable" && input_key === "godown_name") {
                                                nextField = typeof index === "number" ? `value${index} ` : "value";
                                            }
                                        }

                                        const nextRef = nextField ? (inputRefs?.current?.[nextField] || inputRefs?.[nextField]?.current) : null;

                                        if (nextRef) {
                                            nextRef.focus();
                                            if (nextRef.setSelectionRange) nextRef.setSelectionRange(0, nextRef.value?.length || 0);
                                        } else if (fieldIdx === fields.length - 1 || !nextField) {
                                            setSubmitConfirm('Accept')
                                            const currentKey = typeof index === "number" ? `${input_key}${index} ` : input_key;
                                            const currentRef = inputRefs?.current?.[currentKey] || inputRefs?.[currentKey]?.current;
                                            if (currentRef) currentRef.blur();
                                        }
                                        dispatch(closeModal(typeof index === "number" ? `${input_key}${index} ` : input_key))
                                    }
                                }}
                            >
                                {index !== -1 ? (
                                    < >
                                        {name?.substring(0, index)}
                                        <span style={{ color: 'red' }}>{name?.substring(index, index + input_value?.length)}</span>
                                        {name?.substring(index + input_value?.length)}
                                    </>
                                ) : (
                                    name
                                )}
                            </Link>
                        );
                    })
                }

            </div>
        </div>
    )
})

export default React.memo(DropdownForDynamicInput)
